module.exports = __webpack_public_path__ + "src/img/artist/indexpic09.jpg?ca6f41b20fdea9ee6d530d0109f49735";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/indexpic09.jpg
// module id = 136
// module chunks = 0